import { ComponentRef, Directive, ElementRef, EmbeddedViewRef, HostListener, Input, Renderer2, ViewContainerRef } from '@angular/core';
import {TooltipComponent} from './tooltip.component';
import { TooltipBehavior, TooltipPosition, TooltipTheme } from '../../../model/entity';

@Directive({
    selector: '[winoTooltip]'
})
export class TooltipDirective {

    @Input('tooltipText')
    tooltipText: string = "";

    @Input('tooltipSecondaryText')
    tooltipSecondaryText: string = "";

    @Input('tooltipPosition')
    position: string = "";

    @Input('tooltipWidth')
    tooltipWidth: string = "";

    @Input('tooltipTheme')
    theme: string = "";

    @Input('tooltipBehavior')
    behavior: string = "";

    private componentRef: ComponentRef<any> = null;

    private tooltipPosition: TooltipPosition;
    private tooltipTheme: TooltipTheme;
    private tooltipBehavior: TooltipBehavior;

    private showTimeout: number;
    private hideTimeout: number;

    private readonly showDelay: number = 300;
    private readonly hideDelay: number = 500;

    constructor(private readonly elementRef: ElementRef, private readonly viewContainerRef: ViewContainerRef,
        private readonly renderer: Renderer2) {
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    // @HostListener('mouseover')
    @HostListener('mouseenter')
    onMouseEnter(): void {
        console.log("TooltipDirective - onMouseEnter()");
        this.showTimeout = window.setTimeout(this.initializeTooltip.bind(this, this.showDelay));
    }

    // @HostListener('mouseout')
    @HostListener('mouseleave')
    onMouseLeave(): void {
        // setTimeout( () => {
        //    const tooltip: HTMLElement = this.elementRef.nativeElement.querySelector('.winoTooltipStyle');
        //    this.renderer.removeChild(this.elementRef.nativeElement, tooltip);
        //}, 1000);
        console.log("TooltipDirective - onMouseLeave()");
        this.hideTimeout = window.setTimeout(this.destroy.bind(this), this.hideDelay);
    }

    @HostListener('touchstart', ['$event'])
    onTouchStart($event: TouchEvent): void {
        console.log("TooltipDirective - onTouchStart()");
        $event.preventDefault();
        this.showTimeout = window.setTimeout(this.initializeTooltip.bind(this), this.showDelay);
    }

    @HostListener('touchend')
    onTouchEnd(): void {
        console.log("TooltipDirective - onTouchEnd()");
        this.hideTimeout = window.setTimeout(this.destroy.bind(this), this.hideDelay);
    }

    @HostListener('mousemove', ['$event'])
    onMouseMove($event: MouseEvent): void {
        if(this.componentRef != null && this.tooltipBehavior === TooltipBehavior.DYNAMIC) {
            this.componentRef.instance.mouseHorizontalPosition = $event.clientX;
            this.componentRef.instance.mouseVerticalPosition = $event.clientY;
            this.componentRef.instance.tooltipText = this.tooltipText;
            this.componentRef.instance.tooltipSecondaryText = this.tooltipSecondaryText;
        }
    }

     initializeTooltip(): void {
        // const myTooltip = this.createTooltip();
        // this.renderer.appendChild(this.elementRef.nativeElement, myTooltip);
        if(this.componentRef === null) {
            // this.componentRef = this.viewContainerRef.createComponent(TooltipComponent);
            //const componentFactory: ComponentFactory<any> = this.componentFactoryResolver.resolveComponentFactory(TooltipComponent);
            this.componentRef = this.viewContainerRef.createComponent(TooltipComponent);
            // this.componentRef = componentFactory.create(this.injector);
            // this.appRef.attachView(this.componentRef.hostView);
            const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            document.body.appendChild(domElem);
            this.setTooltipComponentProperties();
        }
     }
/**************************
    createTooltip(): HTMLElement {
        const tooltip: HTMLElement = this.renderer.createElement("div");
        const text = this.renderer.createText(this.tooltipText);
        this.renderer.appendChild(tooltip, text);
        this.renderer.addClass(tooltip, 'winoTooltipStyle');
        this.renderer.setStyle(tooltip, 'position', 'absolute');
        return tooltip;
    }
*************************/

    private setTooltipComponentProperties() {
        if(this.componentRef !== null) {
            this.componentRef.instance.tooltipText = this.tooltipText;
            this.componentRef.instance.tooltipSecondaryText = this.tooltipSecondaryText;
            this.componentRef.instance.tooltipPosition = this.getTooltipPosition();
            this.componentRef.instance.tooltipWidth = this.getTooltipWidth();
            this.componentRef.instance.tooltipTheme = this.getTooltipTheme();
            this.componentRef.instance.tooltipBehavior = this.getTooltipBehavior();
            
            console.log(this.componentRef.instance.tooltipText);
            const {left, right, top, bottom} = this.elementRef.nativeElement.getBoundingClientRect();
            console.log("TooltipDirective - setTooltipComponentProperties - Native element position. LEFT: " + left + " - RIGHT: " + right + " - BOTTOM: " + bottom + " - TOP: " + top + " - TooltipPosition: " + this.tooltipPosition);
            console.log("TooltipDirective - setTooltipComponentProperties - Browser window size: " + window.innerWidth + " x " + window.innerHeight);
            console.log("TooltipDirective - setTooltipComponentProperties - Screen size: " + screen.width + " x " + screen.height);


            // const domElem: HTMLElement = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            // console.log("TOOLTIP LENGTH: " + domElem.clientWidth);
            switch(this.tooltipPosition) {
                case TooltipPosition.BELOW:
                case TooltipPosition.DEFAULT: {
                    this.componentRef.instance.absoluteHorizontalPosition = Math.round( (right - left) / 2 + left);
                    this.componentRef.instance.absoluteVerticalPosition = Math.round(bottom);
                    this.componentRef.instance.tooltipPosition = TooltipPosition.BELOW;
                    break;
                }
                case TooltipPosition.ABOVE: {
                    this.componentRef.instance.absoluteHorizontalPosition = Math.round( (right - left) / 2 + left);
                    this.componentRef.instance.absoluteVerticalPosition = Math.round(top);
                    break;
                }
                case TooltipPosition.RIGHT: {
                    this.componentRef.instance.absoluteHorizontalPosition = Math.round(right);
                    this.componentRef.instance.absoluteVerticalPosition = Math.round( (bottom - top) / 2 + top);
                    break;
                }
                case TooltipPosition.LEFT: {
                    this.componentRef.instance.absoluteHorizontalPosition = Math.round(left);
                    this.componentRef.instance.absoluteVerticalPosition = Math.round( (bottom - top) / 2 + top);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }

    destroy(): void {
        window.clearTimeout(this.showTimeout);
        window.clearTimeout(this.hideTimeout);
        if(this.componentRef !== null) {
            this.viewContainerRef.detach();
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    private getTooltipPosition(): TooltipPosition {
        switch(this.position) {
            case "above": this.tooltipPosition = TooltipPosition.ABOVE; break;
            case "below":  this.tooltipPosition = TooltipPosition.BELOW; break;
            case "left":  this.tooltipPosition = TooltipPosition.LEFT; break;
            case "right":  this.tooltipPosition = TooltipPosition.RIGHT; break;
            default:  this.tooltipPosition = TooltipPosition.DEFAULT; break;
        }
        return this.tooltipPosition;
    }

    private getTooltipWidth(): number {
        let returnValue: number = +this.tooltipWidth;
        if (Number.isNaN(returnValue) || returnValue < 1) {
            return 170;
        } else {
            return returnValue;
        }
    }

    private getTooltipTheme(): TooltipTheme {
        switch(this.theme) {
            case "light": this.tooltipTheme = TooltipTheme.LIGHT; break;
            case "dark": this.tooltipTheme = TooltipTheme.DARK; break;
            default:  this.tooltipTheme = TooltipTheme.DARK; break;
        }
        return this.tooltipTheme;
    }

    private getTooltipBehavior(): TooltipBehavior {
        switch(this.behavior) {
            case "hover": this.tooltipBehavior = TooltipBehavior.HOVER; break;
            case "dynamic": this.tooltipBehavior = TooltipBehavior.DYNAMIC; break;
            default:  this.tooltipBehavior = TooltipBehavior.HOVER; break;
        }
        return this.tooltipBehavior;
    }
}
